import axios from 'axios'
import { tokens } from 'locales/tokens';

export const getAxios = (baseURL: string | undefined, $alert: Function, t: Function, setBlock?: Function, setIsExcel?: Function) => {
    //create an axios instance

    const axiosInstance = axios.create({
        baseURL,
        headers: {
            "Accept-Language": localStorage.getItem("i18nextLng"),
        },
    })

    //요청 타임아웃 설정
    // axiosInstance.defaults.timeout = 5000
    axiosInstance.defaults.withCredentials = true

    //요청 인터셉터 추가
    axiosInstance.interceptors.request.use(
        (config) => {
            const auhtorization = localStorage.getItem('rdmsToken')

            if (!auhtorization) {
                window.location.href = '/#/login'
            }

            config.headers.Authorization = auhtorization

            if (config.responseType === 'blob' && setBlock && setIsExcel) {
                setBlock(true)
                setIsExcel(true)
            }

            return config
        },
        (error) => {
            console.log(error) //디버깅
            return Promise.reject(error)
        },
    )

    //응답 인터셉터 추가
    axiosInstance.interceptors.response.use(
        async (response) => {
            // Content-Type을 대소문자 구분 없이 가져오기
            const contentType = response.headers['content-type'] || response.headers['Content-Type'] || ''
            const contentTypeLower = contentType.toLowerCase()

            const res = response.data
            // Blob 응답인 경우 먼저 처리
            if (res instanceof Blob) {
                if (contentTypeLower === 'application/octet-stream') {
                    const href = URL.createObjectURL(new Blob([res], { type: 'application/octet-stream' }))

                    // create "a" HTML element with href to file & click
                    const link = document.createElement('a')
                    link.href = href
                    link.setAttribute('download', decodeURI(response.headers['timf-file-name'] || response.headers['Timf-File-Name'] || ''))
                    document.body.appendChild(link)
                    link.click()

                    // clean up "a" element & remove ObjectURL
                    document.body.removeChild(link)
                    URL.revokeObjectURL(href)
                    setBlock && setBlock(false)
                    setIsExcel && setIsExcel(false)
                    return
                } else if (contentTypeLower.includes('application/pdf') || contentTypeLower.startsWith('image/')) {
                    // PDF 또는 이미지 타입(PNG, JPEG 등) 처리
                    setBlock && setBlock(false)
                    setIsExcel && setIsExcel(false)
                    // response 객체 전체를 반환하여 headers 정보도 포함
                    return res
                } else {
                    // Content-Type이 없거나 알 수 없는 Blob인 경우 기본 처리 (PDF/이미지로 가정)
                    setBlock && setBlock(false)
                    setIsExcel && setIsExcel(false)
                    return res
                }
            }

            // Blob이 아닌 경우에만 JSON 파싱 시도
            const { isSuccess, error, data } = res

            if (isSuccess) {
                return data
            }else if (isSuccess === undefined) {
              // responseType 이 blob인 경우 에러 처리
                setBlock && setBlock(false)
                setIsExcel && setIsExcel(false)
                return null
            }
            else {
                setBlock && setBlock(false)
                setIsExcel && setIsExcel(false)
                await $alert({
                    title: t(tokens.common.failure),
                    text: error,
                    icon: 'error',
                })
                return null
            }
        },

        async (error) => {
            const { response, config, code } = error

            if (!response && code === 'ERR_NETWORK') {
                await $alert({
                    title: t(tokens.common.network_error),
                    text: t(tokens.common.cannot_connect_server),
                    icon: 'error',
                })
                return
            }

            const { status, data } = response

            switch (status) {
                case 401:
                    localStorage.setItem('rdmsToken', `Bearer ${data.token}`)
                    return axiosInstance(config)
                case 403:
                    window.location.href = '/#/login'
                    return
                default:
                    return Promise.reject(error)
            }
        },
    )

    return axiosInstance
}

export const download = async (baseURL: string | undefined, uri: string, fileNm: string) => {
    if (!baseURL) {
        return
    }

    const axiosInstance = axios.create({
        baseURL,
    })

    axiosInstance.defaults.withCredentials = true

    const response = await axios.get(`${baseURL}${uri}`, {
        responseType: 'blob',
    })

    const href = URL.createObjectURL(response.data)
    const link = document.createElement('a')
    link.href = href
    document.body.appendChild(link)
    link.setAttribute('download', decodeURI(fileNm ? fileNm : 'download'))
    link.click()

    // clean up "a" element & remove ObjectURL
    document.body.removeChild(link)
    URL.revokeObjectURL(href)
}
